const BASE_URL = "https://api.snow.iosx.in/api/v1/";

API_URL = "https://api.snow.iosx.in/";

NINEBOX_BASE_URL = "https://9boxnow.com";
NINEBOX_API_URL = "https://api.9boxnow.com/api/v1/";

ORGCHART_API_URL = "https://api.orgchrat.iosx.in/api/v1/";
ORGCHART_BASE_URL = "https://orgchartednow.com";

export default BASE_URL;
export var API_URL;
export var NINEBOX_API_URL;
export var ORGCHART_API_URL;
export var NINEBOX_BASE_URL;
export var ORGCHART_BASE_URL;
